module.exports = __webpack_public_path__ + "img/recruitee.a5ca2cc6.jpg";